export default __webpack_public_path__ + "static/media/tab_3.355b6859.png";